//https://stackoverflow.com/questions/47945851/change-display-name-for-firebase-google-auth-provider

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { useMyContext } from "../MyContext";

//const { data } = useMyContext();
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

var firebaseConfig = "";

const firebaseConfigDev = {
  apiKey: process.env.REACT_APP_FIREBASE_DEV_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DEV_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_DEV_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_DEV_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_DEV_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_DEV_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_DEV_MEASUREMENT_ID,
};
const firebaseConfigProd = {
  apiKey: process.env.REACT_APP_FIREBASE_PROD_API_KEY,
  authDomain: "auth.koodums.com", //process.env.REACT_APP_FIREBASE_PROD_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROD_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_PROD_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_PROD_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_PROD_APP_ID,
};
const firebaseConfigTest = {
  apiKey: process.env.REACT_APP_FIREBASE_TEST_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_TEST_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_TEST_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_TEST_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_TEST_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_TEST_APP_ID,
};

firebaseConfig = firebaseConfigDev;

if (
  window.location.href?.includes("dev") ||
  window.location.href.includes("localhost") ||
  window.location.href?.includes("superapp-479920") // superapp-dev project
) {
  firebaseConfig = firebaseConfigDev;
} else if (window.location.href?.includes("test")) {
  firebaseConfig = firebaseConfigTest;
} else if (window.location.href?.includes("agent-builder")) {
  firebaseConfig = firebaseConfigProd;
}

// firebaseConfig = firebaseConfigProd;
console.log("=== Firebase Config Debug ===");
console.log("authDomain:", firebaseConfig.authDomain);
console.log("projectId:", firebaseConfig.projectId);
console.log("currentUrl:", window.location.href);
console.log("Full config:", JSON.stringify(firebaseConfig, null, 2));
console.log("===========================");

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
